var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes['light'].background })},[_c('router-view'),_c('SnackBar',{attrs:{"text":_vm.delayedAlertText,"type":_vm.alertType},on:{"closed":function($event){return _vm.onSnackClosed()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }